export const TRIAL_DASHBOARD_URL = '/v2/#/scheduling/dashboard';
